import { useCallback } from 'react';
import { deselected } from '../../ReferralFormFields/utils/selectField';
import { removeSelectedGroupFields } from './removeGroupFields';
import {
  handleDeselectedProgram,
  handleSelectedProgram,
} from './programSelectHelpers';

export default function useProgramSelect({
  feeScheduleProgramId,
  selectedFields,
  setFeeScheduleProgramId,
}) {
  const removeSelectedFieldsExceptIndex = useCallback((index) => {
    const providersIds = selectedFields.map((field) => field.group.value.id);
    const toRemoveIds = providersIds.filter((id) => id !== selectedFields[index].group.value.id);
    removeSelectedGroupFields(selectedFields, toRemoveIds);
  }, [selectedFields]);

  const feeScheduleContext = { feeScheduleProgramId, removeSelectedFieldsExceptIndex, setFeeScheduleProgramId };

  const onProgramSelect = useCallback((program, index) => {
    if (deselected(program)) {
      handleDeselectedProgram(feeScheduleContext, index);
    } else {
      handleSelectedProgram(program, feeScheduleContext, index);
    }
  }, [feeScheduleContext]);

  return { onProgramSelect };
}
